function areSetsEqual(arr1, arr2) {
    // Convierte ambos arrays en Sets
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);

    // Verifica si tienen el mismo tamaño
    if (set1.size !== set2.size) return false;

    // Verifica si todos los elementos de set1 están en set2
    for (let elem of set1) {
        if (!set2.has(elem)) return false;
    }

    return true;
}

export default {
    randomNumbers: (length, max) =>
        [...new Array(length)].map(() => Math.round(Math.random() * max)),
    areSetsEqual,
};
